/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineVatDto } from './traveline-vat-dto';
import {
    TravelineVatDtoFromJSON,
    TravelineVatDtoFromJSONTyped,
    TravelineVatDtoToJSON,
    TravelineVatDtoToJSONTyped,
} from './traveline-vat-dto';

/**
 * Rate plan entity
 * @export
 * @interface TravelineBookingRatePlanRsDto
 */
export interface TravelineBookingRatePlanRsDto {
    /**
     * Rate plan ID
     * @type {string}
     * @memberof TravelineBookingRatePlanRsDto
     */
    id: string;
    /**
     * Rate plan name
     * @type {string}
     * @memberof TravelineBookingRatePlanRsDto
     */
    name: string;
    /**
     * Rate plan description
     * @type {string}
     * @memberof TravelineBookingRatePlanRsDto
     */
    description: string;
    /**
     * 
     * @type {TravelineVatDto}
     * @memberof TravelineBookingRatePlanRsDto
     */
    vat?: TravelineVatDto;
}

/**
 * Check if a given object implements the TravelineBookingRatePlanRsDto interface.
 */
export function instanceOfTravelineBookingRatePlanRsDto(value: object): value is TravelineBookingRatePlanRsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function TravelineBookingRatePlanRsDtoFromJSON(json: any): TravelineBookingRatePlanRsDto {
    return TravelineBookingRatePlanRsDtoFromJSONTyped(json, false);
}

export function TravelineBookingRatePlanRsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingRatePlanRsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'vat': json['vat'] == null ? undefined : TravelineVatDtoFromJSON(json['vat']),
    };
}

  export function TravelineBookingRatePlanRsDtoToJSON(json: any): TravelineBookingRatePlanRsDto {
      return TravelineBookingRatePlanRsDtoToJSONTyped(json, false);
  }

  export function TravelineBookingRatePlanRsDtoToJSONTyped(value?: TravelineBookingRatePlanRsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'vat': TravelineVatDtoToJSON(value['vat']),
    };
}

